import React from 'react';
import styles from '../OrderDetailsModal.module.scss';
import {EditIcon, PackageIcon} from '../icons';
import ButtonWithIcon from 'components/ButtonWithIcon';
import {OrderType, Prescription} from 'types';
import ProductItem from 'pages/RequestDetails/components/ProductItem';
import api from 'api';
import {useMutation} from 'react-query';

interface ProductListProps {
  products: Prescription[] | undefined;
  onEditProduct: () => void;
  refetch: () => void;
  orderType?: OrderType;
}

const updatePaymentMethod = async ({
  drugId,
  payment_method,
}: {
  drugId: number;
  payment_method: string;
}) => {
  const {data} = await api.patch<any>(`/requests/drug/${drugId}/`, {
    payment_method,
  });
  return data;
};
const ProductList: React.FC<ProductListProps> = ({
  products,
  onEditProduct,
  refetch,
  orderType,
}) => {
  const {mutateAsync: onUpdatePaymentMethod} = useMutation({
    mutationFn: updatePaymentMethod,
    onSuccess: () => {
      refetch();
    },
  });
  return (
    <div className={styles.card}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>
          <PackageIcon width={24} height={24} color="#1A6AE5" />
          Products
        </h2>
        <ButtonWithIcon
          icon={<EditIcon width={16} height={16} />}
          color="ghost"
          size="md"
          onClick={onEditProduct}
        />
      </div>

      <div className={styles.productList}>
        {products?.map((product, index) => (
          <ProductItem
            disabledToCheck={false}
            selectedSplitItems={[]}
            setSelectedSplitItems={() => {}}
            key={`${product.id}-${index}`}
            product={product}
            refetch={refetch}
            orderType={orderType}
            onUpdatePaymentMethod={onUpdatePaymentMethod}
          />
        ))}
        {products?.length === 0 && (
          <p className={styles.no_products}>No products</p>
        )}
      </div>
    </div>
  );
};

export default ProductList;
